export function  urlImg() {
   var url = 'http://hout.kehui.cloud/'
    return url
}

export default {
    urlImg,
}